import { SET_CUSTOM_FIELD_4 } from 'actions';

export function setCustomField4(sourceType: string) {
  return { sourceType, type: SET_CUSTOM_FIELD_4 };
}
